"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
var styleUtilities_1 = require("../../../../util/styleUtilities");
var Table_static_1 = require("../Table.static");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            '& td': {
                borderBottom: theme_1.default.borders.primary,
            },
            display: 'table-row',
            '& td, & th': {
                display: 'table-cell',
                paddingTop: Table_static_1.tableRowPaddingTopBottom,
                paddingBottom: Table_static_1.tableRowPaddingTopBottom,
            },
            '& td:first-child, & th:first-child': {
                paddingLeft: Table_static_1.tableRowPaddingLeftRight,
            },
            '& td:last-child, & th:last-child': {
                paddingRight: Table_static_1.tableRowPaddingLeftRight,
            },
        },
        rootCompact: {
            '& td, & th': {
                display: 'table-cell',
                paddingTop: 12,
                paddingBottom: 12,
            },
        },
        rootAlternateColor: {
            '&:nth-child(odd)': {
                backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.2),
            },
        },
        spacing: function (_a) {
            var columnGap = _a.columnGap;
            return ({
                '& td, & th': {
                    paddingLeft: "calc(".concat(columnGap, " / 2)"),
                    paddingRight: "calc(".concat(columnGap, " / 2)"),
                },
            });
        },
        cell: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        pointer: {
            cursor: 'pointer',
        },
        justifyLeft: {
            justifyContent: 'flex-start',
        },
        justifyRight: {
            justifyContent: 'flex-end',
        },
        sortIcon: {
            marginLeft: 8,
        },
        sortIconNone: {
            opacity: 0.5,
        },
        disabledRow: {
            opacity: 0.5,
        },
        highlightedRow: {
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.2), " !important"),
        },
        importantRow: {
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5), " !important"),
        },
    });
});
